module.exports = __webpack_public_path__ + "img/大自然.4617b57d.png";